import {useCallback} from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {IGameContextViewModel} from "../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GameNavBarItemMobileComponent} from "../game-nav-bar-item.mobile.component";

interface IGameNavBarItemComponentProps {
    gameContext: IGameContextViewModel;
}

export const AddFundsGameNavBarMobileComponent: React.FC<IGameNavBarItemComponentProps> = observer((props) => {
    const services = useServices();

    const _sentenceCase = useCallback((str: string): string => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }, []);

    if(!props.gameContext.supportsAddInGameFunds) {
        return null;
    }

    const _addInGameFunds = async () => {
        services.analytics.sendOrbitUserFlowEvent("Navigation", "AddFunds", "InGameBottomNavBar");
        await props.gameContext.addInGameFunds({
            isCalledFromCashierClose: false
        });
    }

    const AddFundsIcon = services.theme.currentTheme.icons.addFundsIcon;

    return <GameNavBarItemMobileComponent
        Icon={AddFundsIcon}
        text={_sentenceCase(services.translation.translate("ADD_FUNDS_GAME_NAVBAR_BUTTON"))}
        onClick={_addInGameFunds}
    />;
});
